import { API_BASE_URL, API_TOKEN } from '../config/apiConfig';
import React, { useState, useEffect, useRef } from "react";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import { NavLink } from "react-router-dom";
import store from "../store/store";
import print from "print-js";
import "../css/t-care.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/free-mode";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import axios from "axios";
import "toastr/build/toastr.min.css"; // Import toastr CSS
import toastr from "toastr";
import { Oval } from "react-loader-spinner";
import { useNavigate } from 'react-router-dom';
import Select from "react-select";
import PrivacyPolicy from './PrivacyPolicy'; // Pastikan jalur ini sesuai dengan lokasi file PrivacyPolicy.js Anda
import StickyExploreButton from "./components/StickyExploreButton";
import StickyLeftButton from "./components/StickyLeftButton";
import AftersalesExploreService from "./components/AftersalesExploreService";
import { ga4Event } from './util/ga4';

function TCare ()
{
  const pdfRef = useRef( null );
  const [ downloadWarranty, setDownloadWarranty ] = useState( null );
  const [ downloadCoating, setDownloadCoating ] = useState( null );
  const [ downloadAbility, setDownloadAbility ] = useState(false);
  const [ loading, setLoading ] = useState( false );
  const [ downloadCertificate, setDownloadCertificate ] = useState( null );
  const [ download, setDownload ] = useState( null );
  const [ type, setType ] = useState( 1 );
  const [ vin, setVinInput ] = useState( "" );
  const [ imageUrl, setImageUrl ] = useState( "" );
  const [ imageUrl2, setImageUrl2 ] = useState( "" );
  const [ message, setmessage ] = useState( "" );
  const [ description, setDescription ] = useState( "" );
  const [ kendaraan, setkendaraan ] = useState( "" );
  const [ warna, setwarna ] = useState( "" );
  const [ hidebutton, sethidebutton ] = useState( 0 );
  const [ guideline, setguideline ] = useState( "" );
  const [ tagline, settagline ] = useState( "" );
  const [ color, setcolor ] = useState( "" );
  const [ product, setproduct ] = useState( "" );
  const [ submission, setsubmission ] = useState( "" );
  const [ potentialDataSubmission, setPotentialDataSubmission ] = useState( "" );
  const [ programName, setprogramname ] = useState( "" );
  const [ originProgramName, setOriginProgramName ] = useState( "" );
  const [ info, setinfo ] = useState( "" );
  const [ timerValue, setTimerValue ] = useState( 60 ); // Initialize timer value
  const [ uname, setName ] = useState( "" );
  const [ uemail, setEmail ] = useState( "" );
  const [ oldEmail, setOldEmail ] = useState( "" );
  const [ register, setregister ] = useState();
  const [ tableData, settableData ] = useState( [] );
  const [ tableDataCoating, settableDataCoating ] = useState( [] );
  const [ checkServiceNmae, setCheckServiceName ] = useState( "" );
  const [ checkSeriveModel, setCheckserviceModel ] = useState( "" );
  const [ otp1, setOtp1 ] = useState( "" );
  const [ otp2, setOtp2 ] = useState( "" );
  const [ otp3, setOtp3 ] = useState( "" );
  const [ otp4, setOtp4 ] = useState( "" );
  const [ otp5, setOtp5 ] = useState( "" );
  const [ otp6, setOtp6 ] = useState( "" );
  const [ WrongVin, setWrongVin ] = useState( "" );
  const [ checkemptyfield, setcheckemptyfield ] = useState( false );
  const [ isChecked1, setIsChecked1 ] = useState( false );
  const [ isChecked2, setIsChecked2 ] = useState( false );
  const [ showModal, setShowModal ] = useState( false );
  const [ expandedRows, setExpandedRows ] = useState( [] );
  const [ isTableVisible, setIsTableVisible ] = useState( false );
  const [ isTableVisibleCoating, setIsTableVisibleCoating ] = useState( false );
  const [daysInMonth, setDaysInMonth] = useState([]);
  const [ dealerBranchList, setDealerBranchList ] = useState([]);
  const [ selectedBranch, setSelectedBranch ] = useState(null);
  const [ productDeliveryDate, setProductDeliveryDate ] = useState();
  const [ isLockedDeliveryDate, setIsLockedDeliveryDate ] = useState(false);
  const [ isTowasDD, setIsTowasDD ] = useState(false);
  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const handleInputChange = ( event ) =>
  {
    setVinInput( event.target.value );
    setWrongVin( "" );
  };
  const [ preferredBranch, setPreferredBranch ] = useState("");

  const [ selectedYear, setSelectedYear ] = useState( "" );
  const [ selectedMonth, setSelectedMonth ] = useState( "" );
  const [ selectedDay, setSelectedDay] = useState("");
  const [ activeTab, setActiveTab ] = useState( 0 );
  const [ activeTab1, setActiveTab1 ] = useState( 0 );
  const [ secondtab, setsecondtab ] = useState( 0 );

  const handleTabClick = ( index ) =>
  {
    setActiveTab( index );
  };

  const handleTabClick1 = ( index ) =>
  {
    setActiveTab1( index ); // Set the active tab
    if ( index == 0 )
    {
      setDownload( downloadCertificate );
      setType( 1 );
    }

    setActiveTab1( index ); // Set the active tab
    if ( index == 1 )
    {
      setDownload( downloadWarranty );
      setType( 2 );
    }

    setActiveTab1( index ); // Set the active tab
    if ( index == 2 )
    {
      setDownload( downloadCoating );
      setType( 3 );
    }
  };

  const handleregister = ( valueChannge ) =>
  {
    setsecondtab( valueChannge );
  };

  const goBack = ( index1 ) =>
  {
    setActive_tab1( index1 );
  };

  const handleLanjutClick = async () =>
  {
    setLoading( true );
    setDownloadWarranty( "" );
    setDownloadCoating( "" );
    setDownloadCertificate( "" );
    setDownload( "" );
    setName( "" );
    setEmail( "" );
    setDownloadAbility(true);
    setPotentialDataSubmission("");

    if ( vin.length < 1 )
    {
      toastr.error( "Enter the Vin" );
      setLoading( false );
      return;
    }
    try
    {
      const response = await axios.post(
        `${ API_BASE_URL }/checkVin`,
        { vin },
        {
          headers: {
            Authorization: `Bearer ${ API_TOKEN }`,
          },
        }
      );

      if (
        response &&
        response.data &&
        response.data.data &&
        response.data.data.color
      )
      {
        setcolor( response.data.data.color );
        setproduct( response.data.data.color );
        setproduct( response.data.data.color );
        setImageUrl( response.data.imgUrl );
        setImageUrl2( response.data.imgUrl2 );
        settagline( response.data.tagline );
        setDescription( response.data.description );
        setsubmission( response.data.submission );
        setPotentialDataSubmission( response.data.potential_data_submission );
        setprogramname( response.data.program_name );
        setOriginProgramName( response.data.origin_program_name );
        setinfo( response.data.info );
        setguideline( response.data.tagline );
        setName( response.data.data.name );
        // setEmail( response.data.data.email );
        setOldEmail(response.data.data.email);
        setDownloadCertificate( response.data.download_certificate );
        setDownloadWarranty( response.data.download_warranty );
        setDownloadCoating( response.data.download_coating );
        setDownload( response.data.download_certificate );
        setProductDeliveryDate( response.data.delivery_date );
        setIsTowasDD( response.data.is_towas_dd );
        setSelectedBranch( response.data.dealer_branch_id );

        // if ( response.data.download_warranty == null )
        // {
        //   sethidebutton( 1 );
        // } else
        // {
        //   sethidebutton( 0 );
        // }
        setLoading( false );
        setsecondtab( 2 );
        setregister( 2 );
      } else
      {
        setLoading( false );

        setImageUrl( response.data.imgUrl );
        setImageUrl2( response.data.imgUrl2 );
        settagline( response.data.tagline );
        setguideline( response.data.guideline );
        setVinInput( response.data.vin );
        setmessage( response.data.message );
        setDescription( response.data.description );
        setsubmission( response.data.submission );
        setProductDeliveryDate( response.data.delivery_date );
        setIsTowasDD( response.data.is_towas_dd );

        toastr.error( response.data.status );
        setLoading( false );
        setsecondtab( 1 );
        setregister( 2 );
      }

      // setActiveCircle(activeCircle + 1);
    } catch ( error )
    {
      // Handle error here
      setLoading( false );
      if ( error.response )
      {
        if ( error.response.data.message == "Server Error" )
        {
          toastr.error("Kendaraan tidak terdaftar.");
          setWrongVin( "" );
        } else
        {
          toastr.error( error.response.data.message );
          setWrongVin( error.response.data.message );
        }
      } else
      {
        toastr.error("Kendaraan tidak terdaftar.");
      }
      // setsecondtab(1);
      setregister( 1 );
    }
  };

  useEffect(() => {
    if (productDeliveryDate) {
      const dateObj = new Date(productDeliveryDate);
      setSelectedYear(dateObj.getFullYear());
      setSelectedMonth(parseInt(dateObj.getMonth()) + 1);
      setSelectedDay(dateObj.getDate());

      if(isTowasDD){
        setIsLockedDeliveryDate(Boolean(productDeliveryDate));
      }
    }
  }, [productDeliveryDate]);

  const handleMonthChange = ( event ) =>
  {
    setSelectedMonth( event.target.value ); // Update selected month when the dropdown value changes
  };

  // const handleDayChange = ( event ) =>
  // {
  //   console.log(selectedDay);
  //   setSelectedDay( event.target.value ); // Update selected month when the dropdown value changes
  // };

  useEffect( () =>
  {
    const currentYear = new Date().getFullYear(); // Get the current year
    const years = Array.from(
      { length: currentYear - 1999 },
      ( _, index ) => 2000 + index
    ); // Create an array of years from 2000 to the current year
    setSelectedYear( currentYear.toString() ); // Set the default selected year to the current year
  }, [] );

  useEffect(() => {
    // const monthIndex = months.indexOf(selectedMonth);
    const lastDay = new Date(selectedYear, selectedMonth, 0).getDate();

    const daysArray = Array.from({ length: lastDay }, (_, i) => i + 1);
    setDaysInMonth(daysArray);
    // setSelectedDay(null);
  }, [selectedMonth]);

  const handleYearChange = ( event ) =>
  {
    setSelectedYear( event.target.value ); // Update selected year when the dropdown value changes
  };

  useEffect(()=>{
    const getDealerBranch = async () => {
      try {
        const response = await axios.get(`${ API_BASE_URL }/dealer-branches`,
          {
            headers: {
              Authorization: `Bearer ${ API_TOKEN }`,
            },
          }
        );
        setDealerBranchList(response.data.data);
      }
      catch(error){
        console.error('Failed to load dealer branch data.');
      }
    }

    getDealerBranch();
    // alert(selectedYear)
  }, []);

  useEffect(() => {
    const branchFound = branchOptions.find((opt) => opt.value === selectedBranch);
    setPreferredBranch(branchFound ? branchFound.label : '');
  }, [selectedBranch])

  const monthMap = {
    Month: "",
    January: "1",
    February: "2",
    March: "3",
    April: "4",
    May: "5",
    June: "6",
    July: "7",
    August: "8",
    September: "9",
    October: "10",
    November: "11",
    December: "12",
  };

  const submitData = async () =>
  {
    setLoading( true );
    // let selectedMonthValue = monthMap[ selectedMonth ];
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if ( uname.length < 1 )
    {
      toastr.error( "Name is required" );
      setLoading( false );
      return;
    }
    if ( !emailRegex.test( uemail ) )
    {
      toastr.error( "Invalid email format" );
      setLoading( false );
      return;
    }
    if ( !months[selectedMonth - 1] )
    {
      toastr.error( "Month is required"+selectedMonth );
      setLoading( false );
      return;
    }
    if ( selectedYear.length < 1 )
    {
      toastr.error( "Year is required" );
      setLoading( false );
      return;
    }

    if ( preferredBranch.length < 1 )
    {
      toastr.error( "Branch must be selected" );
      setLoading( false );
      return;
    }

    try
    {
      const name = uname;
      const email = uemail;
      const buy_month = selectedMonth;
      const buy_year = selectedYear;
      const buy_day = selectedDay;

      const response = await axios.post(
        `${ API_BASE_URL }/submitData`,
        {
          vin,
          name,
          email,
          buy_day,
          buy_month,
          buy_year,
        },
        {
          headers: {
            Authorization: `Bearer ${ API_TOKEN }`,
          },
        }
      );

      setkendaraan( response.data.kendaraan );
      setName( response.data.name );
      setEmail( response.data.email );
      setVinInput( response.data.vin );
      setwarna( response.data.warna );
      // setSelectedYear( response.data.buy_year );
      // setSelectedMonth( response.data.buy_month );
      // setSelectedDay( parseInt(response.data.buy_day) );
      setLoading( false );
      setsecondtab( 4 );
    } catch ( error )
    {
      setLoading( false );
      if ( error.response )
      {
        toastr.error( error.response.data.message );
      }
    }
  };

  const submitRegister = async () =>
  {
    setLoading( true );
    try
    {
      const name = uname;
      const email = uemail;
      const buy_month = selectedMonth;
      const buy_year = selectedYear;
      const buy_day = selectedDay;
      const branch_name = preferredBranch;

      const response = await axios.post(
        `${ API_BASE_URL }/submitRegister`,
        {
          vin,
          name,
          email,
          buy_day,
          buy_month,
          buy_year,
          branch_name
        },
        {
          headers: {
            Authorization: `Bearer ${ API_TOKEN }`,
          },
        }
      );

      setLoading( false );
      setsecondtab( 5 );
      setTimerValue( 60 );
      countdown();
    } catch ( error )
    {
      setLoading( false );
      if ( error.response )
      {
        toastr.error( error.response.data.message );
      }
    }
  };

  const submitOtp = async () =>
  {
    setLoading( true );
    const selectedMonthValue = monthMap[ selectedMonth ];
    const otp = otp1 + otp2 + otp3 + otp4 + otp5 + otp6;
    setOtp1( "" ); // Empty the value of otp1
    setOtp2( "" ); // Empty the value of otp2
    setOtp3( "" ); // Empty the value of otp3
    setOtp4( "" ); // Empty the value of otp4
    setOtp5( "" ); // Empty the value of otp5
    setOtp6( "" );
    setDownloadAbility(true);
    setsubmission("");
  
    try
    {
      const response = await axios.post(
        `${ API_BASE_URL }/submitOtp`,
        {
          otp,
          vin,
        },
        {
          headers: {
            Authorization: `Bearer ${ API_TOKEN }`,
          },
        }
      );

      setDownloadWarranty( response.data.download_warranty );
      setDownloadCoating( response.data.download_coating );
      setDownloadCertificate( response.data.download_certificate );
      setDownload( response.data.download_certificate );
      setDownloadAbility(response.data.certificate_download_ability);
      setsubmission( response.data.submission );
      setprogramname( response.data.program_name );
      setOriginProgramName( response.data.origin_program_name );
      setLoading( false );

      if ( response.data.vin )
      {
        setsecondtab( 6 );
      }
      // if ( response.data.download_warranty == null )
      // {
      //   sethidebutton( 1 );
      // } else
      // {
      //   sethidebutton( 0 );
      // }
    } catch ( error )
    {
      setLoading( false );
      toastr.error( error.response.data.message );
      setOtp1( "" ); // Empty the value of otp1
      setOtp2( "" ); // Empty the value of otp2
      setOtp3( "" ); // Empty the value of otp3
      setOtp4( "" ); // Empty the value of otp4
      setOtp5( "" ); // Empty the value of otp5
      setOtp6( "" );
    }
  };

  const countdown = () =>
  {
    let intervalId;
    const startTimer = () =>
    {
      intervalId = setInterval( () =>
      {
        setTimerValue( ( prevTimerValue ) =>
        {
          if ( prevTimerValue === 0 )
          {
            clearInterval( intervalId );
            return 0; // Reset timer to 60 seconds
          }
          return prevTimerValue - 1;
        } );
      }, 1000 );
    };

    // Start the timer initially
    startTimer();

    // Clean up the timer on component unmount
    return () => clearInterval( intervalId );
  };

  const sendEmail = async () =>
  {
    setLoading( true );
    try
    {
      const response = await axios.post(
        `${ API_BASE_URL }/sendEmail`,
        {
          vin,
          type,
        },
        {
          headers: {
            Authorization: `Bearer ${ API_TOKEN }`,
          },
        }
      );

      toastr.success( response.data.message );
      setLoading( false );
    } catch ( error )
    {
      setLoading( false );
      toastr.error( error.response.data.message );
    }
  };

  const handleDownload = async () =>
  {
    if ( !download )
    {
      toastr.error( "No PDF data available for download" );
      return;
    }
    try
    {
      // Create a link element
      var link = document.createElement( "a" );

      // Set the href attribute of the link to the PDF file URL
      link.href = download;
      link.setAttribute( "target", "_blank" );

      // Set the download attribute to force download the PDF file
      link.setAttribute( "download", "downloaded_" + vin + ".pdf" );

      // Append the link to the body
      document.body.appendChild( link );

      // Trigger a click event on the link
      link.click();

      // Remove the link from the DOM after triggering download
      document.body.removeChild( link );

      // // Fetch the PDF file using the PDF URL
      // const response = await axios.get(download, { responseType: "blob" });

      // // Create a Blob from the response data
      // const blob = new Blob([response.data], { type: "application/pdf" });

      // // Create a URL for the Blob
      // const url = URL.createObjectURL(blob);

      // // Create a link element
      // const link = document.createElement("a");

      // // Set the href attribute of the link to the URL of the Blob
      // link.href = url;

      // // Set the download attribute to specify the filename
      // link.download = "downloaded_file.pdf";

      // // Simulate a click on the link to trigger the download
      // link.click();
      // // Clean up by revoking the URL object
      // URL.revokeObjectURL(url);
    } catch ( error ) { }
  };

  const handlePrint = () =>
  {
    // store.dispatch({ type: 'SET_PRINT_URL', payload: { download } });
    localStorage.setItem( 'printUrl', download );

    const newTab = window.open( '/print', '_blank' );
    if ( newTab )
    {
      newTab.focus(); // Focus on the new tab
    } else
    {
      toastr.error( 'Try again later' )
    }

  };

  const [ vinn, setVinn ] = useState( "" );
  const [ emaill, setEmaill ] = useState( "" );
  const [ Nodata, setNodata ] = useState( "" );
  const [ serviceHistoryProgram, setServiceHistoryProgram ] = useState( "" );
  const [ Active_tab1, setActive_tab1 ] = useState( 1 );

  const serviceHistory = async () =>
  {
    setLoading( true );
    const vin = vinn;
    const email = emaill;
    try
    {
      const response = await axios.post(
        `${ API_BASE_URL }/serviceHistory`,
        {
          vin,
          email,
        },
        {
          headers: {
            Authorization: `Bearer ${ API_TOKEN }`,
          },
        }
      );

      settableData( response.data.data );
      settableDataCoating( response.data.coating );
      setCheckServiceName( response.data.name );
      setCheckserviceModel( response.data.model );
      setServiceHistoryProgram( response.data.program_name );
      if ( response.data.message == "success." )
      {
        setActive_tab1( 3 );
      }
      // toastr.success(response.data.message);
      setLoading( false );
    } catch ( error )
    {
      setLoading( false );
      setNodata( error.response.data.message );
      setActive_tab1( 2 );
      toastr.error( error.response.data.message );
    }
  };

  const downloadFile = () =>
  {
    const link = document.createElement( 'a' );
    link.href = '/assets/Informasi-Program-Gratis-Biaya-Servis-Berkala.pdf';
    link.target = '_blank'; // Menentukan target sebagai _blank untuk membuka di tab baru
    document.body.appendChild( link );
    link.click();
    document.body.removeChild( link );
  };

  const navigate = useNavigate();

  const goToRecommendation = () =>
  {
    navigate( '/' );
    setTimeout( () =>
    {
      const recommendationSection = document.getElementById( 'recommendation-section' );
      if ( recommendationSection )
      {
        recommendationSection.scrollIntoView( { behavior: 'smooth' } );
      }
    }, 0 );
  };

  const handleCheckbox1Change = ( e ) =>
  {
    setIsChecked1( e.target.checked );
    setShowModal( e.target.checked ); // Tampilkan modal ketika checkbox dicentang
  };

  const handleCheckbox2Change = () =>
  {
    setIsChecked2( !isChecked2 );
  };

  const closeModal = () =>
  {
    setShowModal( false );
  };

  // Check if both checkboxes are checked
  const isBothChecked = isChecked1 && isChecked2;

  // Fungsi untuk toggle visibilitas tabel
  const toggleTableVisibility = () =>
  {
    setIsTableVisible( ( prev ) => !prev );

  };

  const toggleTableVisibilityCoating = () =>
  {
    setIsTableVisibleCoating( ( prev ) => !prev );

  };

  const getTabName = () =>
  {
    switch ( activeTab1 )
    {
      case 0:
        return <strong>{ " " }{ programName }{ " " }</strong>;
      case 1:
        return <strong>{" "}{programName?.includes("Xtra EZ") ? "Extended Warranty" : "Warranty"}{" "}</strong>;
      case 2:
        return <strong>{ " " }Coating{ " " }</strong>;
      default:
        return null;
    }
  };

  const branchOptions = dealerBranchList.map((branch) => ({
    value: branch.id,
    label: branch.name,
  }));

  // Youtube Play Tracker
  useEffect(() => {
      let hasPlayed = false;
      
      const handleMessage = (event) => {
        if (!event.data) return;
      
        let data;
      
        try {
          data = JSON.parse(event.data);
        } catch (e) {
          return; // bukan JSON dari YouTube
        }
      
        // Pastikan ini event dari YouTube
        if (data.event === "onStateChange") {
          // 1 = PLAYING
          if (data.info === 1 && !hasPlayed) {
            hasPlayed = true;
            
            window.dataLayer.push({
                event: 'tcare_content_click',
                menu_section: 'aftersales_product_t_care',
                click_detail: 'T-Care Main Video',
            });
          }
        }
      };
    
      window.addEventListener("message", handleMessage);
    
      return () => {
        window.removeEventListener("message", handleMessage);
      };
  }, []);

  return (

    <div id="navbar_top">
      <Header></Header>
      <StickyExploreButton showItem={[4,7,9,3]} />
      <StickyLeftButton offerIndex={4} />
      <div className="section-1 p-0 " id="section-1">
        <div>
          <img
            src="assets/home-page-slider.png"
            className="d-block w-100"
            alt="Slide 1"
          />
        </div>
      </div>

      <div className="container-fluid p-0 mt-5 ">

        {/* first section */ }
        <div className="container px-lg-5">
          <h5 className='my-3'>Toyota sangat peduli terhadap keamanan dan kenyamanan Anda saat berkendara.<br/>Untuk pembelian unit Toyota start bulan Juli 2022, Anda dapat menikmati program dibawah ini:</h5>
          <div className="section-1">
            <div className="row">
              <div class="col-md-5 d-flex">
                <div class="section-image my-auto">
                  <img src="assets/TCARE-LOGO.png" className="w-100" alt="logo" />
                </div>
              </div>
              <div className="col-md-7">
                <div className="section-content">
                  <p className="text-start fw-bold">T-CARE</p>
                  <p className='text-start mb-3'><strong>Bebas Biaya Jasa Servis Berkala dan Suku Cadang</strong> sebanyak 7x servis selama 3 tahun / <span className='d-inline-block'>60.000 km</span> beserta Extended Warranty 1 tahun / <span className='d-inline-block'>20.000 km</span>.</p>
                  <p className="text-start"><span className='d-inline-block bg-black text-white rounded-pill px-3 py-1'>Seluruh model Toyota kecuali LCGC, Limo, Transmover, Hilux Rangga, Dyna, Etios Sedan</span></p>
                </div>
              </div>
            </div>
          </div>
          <div className="section-1 bg-white">
            <div className="row">
              <div class="col-md-5 order-1 order-md-2 d-flex">
                <div class="section-image my-auto">
                  <img src="assets/TCARE-LITE-LOGO.png" className="w-100" alt="logo" />
                </div>
              </div>
              <div className="col-md-7 order-2 order-md-1">
                <div className="section-content">
                  <p className="text-start fw-bold">T-CARE LITE</p>
                  <p className='text-start mb-3'><strong>Bebas Biaya Jasa Servis Berkala</strong> sebanyak 7x servis selama 3 tahun / <span className='d-inline-block'>60.000 km</span> beserta Extended Warranty 1 tahun / <span className='d-inline-block'>20.000 km</span>.</p>
                  <p className="text-start"><span className='d-inline-block bg-black text-white rounded-pill px-3 py-1'>Khusus untuk LCGC</span></p>
                </div>
              </div>
            </div>
          </div>
          <div className="section-1">
            <div className="row">
              <div class="col-md-5 d-flex">
                <div class="section-image my-auto">
                  <img src="assets/TCARE-LITE-PLUS-LOGO.png" className="w-100" alt="logo" />
                </div>
              </div>
              <div className="col-md-7">
                <div className="section-content">
                  <p className="text-start fw-bold">T-CARE LITE+</p>
                  <p className='text-start mb-3'><strong>Paket tambahan suku cadang untuk servis berkala ke-2 sampai ke-7</strong> selama 3 tahun / <span className='d-inline-block'>60.000 km.</span></p>
                  <p className="text-start"><span className='d-inline-block bg-black text-white rounded-pill px-3 py-1'>Khusus untuk LCGC</span></p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* second section */ }
        <div className="container px-lg-5">
          <div className="section-2 mt-5">
            <div className="row">
              <div class="col-lg-6 d-flex">
                <div class="section-content text-start my-auto">
                  <p className="Check">Check your</p>
                  <h1>Certificate & Service Record!</h1>
                  <p>
                    Cek nomor rangka kendaraan Anda dan dapatkan sertifikat
                    elektroniknya serta catatan servisnya untuk program{ " " }
                    <strong>T-CARE, T-CARE Lite</strong> dan{ " " }
                    <strong>GBSB</strong>.
                  </p>
                </div>
              </div>

              {/* tcare seection */ }
              <div className="col-lg-6 ">
                <ul className="nav nav-pills nav-fill">
                  <li className="nav-item">
                    <a className={ `tabs sertifikat nav-link py-3 li_text_1 ${ activeTab === 0 ? "active" : "" }` } href="javascript:void(0)" onClick={ () => handleTabClick( 0 ) }>Sertifikat Elektronik</a>
                  </li>
                  <li className="nav-item">
                    <a className={ `tabs cataten nav-link py-3 li_text_1 ${ activeTab === 1 ? "active" : "" }` } href="javascript:void(0)" onClick={ () => handleTabClick( 1 ) }>Catatan Servis</a>
                  </li>
                </ul>

                {/* seaech vin section */ }
                <div style={ { display: loading ? "none" : activeTab === 0 ? "block" : "none", } }>
                  <div className="tabs-section" style={ { display: loading ? "none" : secondtab === 0 ? "block" : "none", } }>
                    <div class="circle-tab pt-4">
                      <a href="javascript:void(0)" className={ `mx-3 active` }>
                        <img src="assets/mdi_car-side.png" alt="" />
                      </a>
                      <a href="javascript:void(0)" className={ `mx-4` }>
                        <img src="assets/Group (2).png" alt="" />
                      </a>
                      <a href="javascript:void(0)" className={ `mx-3` }>
                        <img src="assets/Group (3).png" alt="" />
                      </a>
                    </div>
                    <div>
                      <div className="d-md-flex justify-content-between mt-4 mx-4 text-start mx-md-5">
                        <p className="tab-bold-p">Validasi Nomor Rangka</p>
                        <p className="text-danger Langkah_side_text">
                          Langkah 1 - 3
                        </p>
                      </div>
                      <div className="tab-content mx-4 mx-md-5 text-start">
                        <p className="tab-light-bold-p">
                          Nomor Rangka kendaraan Anda dapat ditemukan pada STNK
                          atau BPKB kendaraan Anda
                        </p>
                      </div>
                      <div className="form-group mx-4 mx-md-5 ">
                        <input
                          type="text"
                          className="form-control Masukkan"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                          placeholder="Masukkan 17 Digit No. Rangka Kendaraan"
                          value={ vin }
                          onChange={ handleInputChange }
                        />
                        <p className="mt-1 custom_wrong_chase text-start">
                          { WrongVin }
                        </p>
                      </div>
                      <button
                        className="btn btn-primary Lanjut mt-4 mb-4"
                        onClick={ handleLanjutClick }
                      >
                        Lanjut
                      </button>
                    </div>
                  </div>
                </div>

                {/* info vin step-1 not register */ }
                <div style={ { display: loading ? "none" : activeTab === 0 ? "block" : "none", } }>
                  <div className="tabs-section" style={ { display: loading ? "none" : secondtab === 1 ? "block" : "none", } }>
                    <div class="circle-tab pt-4">
                      <a
                        className={ `mx-3 active cursor-pointer` }
                        onClick={ () => handleregister( 0 ) }
                      >
                        <img src="assets/mdi_car-side.png" alt="" />
                      </a>
                      <a href="javascript:void(0)" className={ `mx-4 active` }>
                        <img src="assets/Group (2).png" alt="" />
                      </a>
                      <a href="javascript:void(0)" className={ `mx-3` }>
                        <img src="assets/Group (3).png" alt="" />
                      </a>
                    </div>
                    <div>
                      <div className="d-md-flex justify-content-between mt-4 mx-4 text-start mx-md-5">
                        <p className="tab-bold-p">Validasi Nomor Rangka</p>
                        <p className="text-danger Langkah_side_text">
                          Langkah 2 - 3
                        </p>
                      </div>
                      <div>
                        <img src={ imageUrl } className="img-extra" />
                        <img src={ imageUrl2 } className="img-extra" />
                        <p className="tab-bold-p">{ vin }</p>
                      </div>
                      <div className="text-start mx-4 mx-md-5">
                        <p className="tab-bold" dangerouslySetInnerHTML={ { __html: tagline } } />
                        <p className="tab-bold" dangerouslySetInnerHTML={ { __html: description } } />
                        <p className="tab-bold" dangerouslySetInnerHTML={ { __html: submission } } />
                        <p style={ { color: "#D71921" } } className="tab-bold-p">
                          { guideline }
                        </p>
                      </div>
                      <div className="mb-4">
                        <button
                          className="btn btn-primary Lanjut mt-4 ms-2"
                          onClick={ () => handleregister( 3 ) }
                        >
                          Lanjut
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* info vin step-1 registered */ }
                <div style={ { display: loading ? "none" : activeTab === 0 ? "block" : "none", } }>
                  <div className="tabs-section" style={ { display: loading ? "none" : secondtab === 2 ? "block" : "none", } }>
                    <div class="circle-tab pt-4">
                      <a
                        onClick={ () => handleregister( 0 ) }
                        className={ `mx-3 active cursor-pointer` }
                      >
                        <img src="assets/mdi_car-side.png" alt="" />
                      </a>
                      <a href="javascript:void(0)" className={ `mx-4 active` }>
                        <img src="assets/Group (2).png" alt="" />
                      </a>
                      <a href="javascript:void(0)" className={ `mx-3` }>
                        <img src="assets/Group (3).png" alt="" />
                      </a>
                    </div>
                    <div>
                      <div className="d-md-flex justify-content-between mt-4 mx-4 text-start mx-md-5">
                        <p className="tab-bold-p">Validasi Nomor Rangka</p>
                        <p className="text-danger Langkah_side_text">
                          Langkah 2 - 3
                        </p>
                      </div>
                      <div>
                        <img src={ imageUrl } className="img-extra" />
                        <img src={ imageUrl2 } className="img-extra" />
                        <p className="tab-bold-p">{ vin }</p>
                      </div>
                      <div className="text-start mx-4 mx-md-5">
                        <p className="tab-bold" dangerouslySetInnerHTML={ { __html: info } } />
                        <p className="tab-bold" dangerouslySetInnerHTML={ { __html: tagline } } />
                        <p className="tab-bold" dangerouslySetInnerHTML={ { __html: description } } />
                        <p className="tab-bold" dangerouslySetInnerHTML={ { __html: submission } } />
                        <p style={ { color: "#D71921" } } className="tab-bold">
                          Ingin ubah data diri anda? klik { " " }<span className="ubah_diri" onClick={ () => handleregister( 3 ) }>disini</span>
                        </p>
                      </div>

                      <div className="mb-4">

                        <button
                          className="btn btn-primary Lanjut mt-4 ms-2"
                          onClick={ () => handleregister( 6 ) }
                        >
                          Lanjut
                        </button>
                      </div>

                    </div>
                  </div>
                </div>

                <div style={ { display: loading ? "none" : activeTab === 0 ? "block" : "none", } } >
                  <div className="tabs-section" style={ { display: loading ? "none" : secondtab === 3 ? "block" : "none", } } >
                    <div class="circle-tab pt-4">
                      <a
                        onClick={ () => handleregister( 0 ) }
                        className={ `mx-3 active cursor-pointer` }
                      >
                        <img src="assets/mdi_car-side.png" alt="" />
                      </a>
                      <a href="javascript:void(0)" className={ `mx-4 active` }>
                        <img src="assets/Group (2).png" alt="" />
                      </a>
                      <a href="javascript:void(0)" className={ `mx-3` }>
                        <img src="assets/Group (3).png" alt="" />
                      </a>
                    </div>
                    <div>
                      <div className="d-md-flex justify-content-between mt-4 mx-4 text-start mx-md-5">
                        <p className="tab-bold-p">Validasi Nomor Rangka</p>
                        <p className="text-danger Langkah_side_text">
                          Langkah 2 - 3
                        </p>
                      </div>
                      <div className="form-group mx-4 mx-md-5 text-start ">
                        <label className="input_label">Nama sesuai KTP</label>
                        <input
                          type="text"
                          className="form-control Masukkan"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                          placeholder="Name"
                          value={ uname }
                          onChange={ ( e ) => setName( e.target.value ) }
                        />
                      </div>

                      <div className="form-group mx-4 mx-md-5 text-start ">
                        <label className="input_label">Email</label>
                        <input
                          type="email"
                          className="form-control Masukkan"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                          placeholder={ oldEmail ?? "Email" }
                          autoComplete={false}
                          // value={ uemail }
                          onChange={ ( e ) => setEmail( e.target.value ) }
                        />
                        {/* <span className='tiny-text'>Catatan : Masukkan Email aktif untuk mendapatkan program menarik dari Toyota</span> */ }
                      </div>

                      <div className="form-group mx-4 mx-md-5 text-start">
                        <label className="input_label">
                          Tahun, Bulan & Tanggal kendaraan diterima oleh pelanggan
                        </label>
                        <div className="d-flex">
                          <div className="me-4 w-100">
                            <select
                              className="form-select"
                              aria-label="Select Year"
                              value={ selectedYear }
                              onChange={ handleYearChange }
                              style={ { border: "none" } }
                              disabled={isLockedDeliveryDate}
                            >
                              <option value="">Year</option>
                              { Array.from(
                                { length: new Date().getFullYear() - 1999 },
                                ( _, index ) => (
                                  <option
                                    key={ 2000 + index }
                                    value={ 2000 + index }
                                  >
                                    { 2000 + index }
                                  </option>
                                )
                              ) }
                            </select>
                          </div>
                          <div className="me-4 w-100">
                            <select
                              className="form-select"
                              aria-label="Select Month"
                              value={ selectedMonth }
                              onChange={ handleMonthChange }
                              style={ { border: "none" } }
                              disabled={isLockedDeliveryDate}
                            >
                              <option value="">Bulan</option>
                              {months.map((m, k) => (
                                <option key={k+1} value={k+1}>
                                  {m}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="w-100">
                            <select
                              className="form-select"
                              aria-label="Select Date"
                              value={ selectedDay }
                              onChange={(e) => {
                                const value = e.target.value;
                                setSelectedDay(value);
                              }}
                              style={ { border: "none" } }
                              disabled={isLockedDeliveryDate}
                            >
                              <option value="" disabled>Tanggal</option>
                              {daysInMonth.map((day) => (
                                <option key={day} value={day}>
                                  {day}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="form-group mx-4 mx-md-5 text-start ">
                        <label className="input_label">Nama Cabang</label>
                        <Select
                          options={branchOptions}
                          value={branchOptions.find((opt) => opt.value === selectedBranch)}
                          onChange={(option) => {
                            setSelectedBranch(option.value)
                          }}
                          placeholder="Pilih Cabang"
                          isSearchable
                        />
                      </div>

                      {/* TODO: Agrement */ }
                      <div className="col-12 agreement">
                        <div className="mb-4">
                          {/* <div>
                            <table>
                              <tr>
                                <td style={ { width: "30px", verticalAlign: "top" } }>
                                  <input
                                    type="checkbox"
                                    style={ { width: "20px" } }
                                    checked={ isChecked1 }
                                    onChange={ handleCheckbox1Change }
                                  />
                                </td>
                                <td style={ { textAlign: "justify" } }>
                                  Dengan mencentang kotak ini, Saya memberikan persetujuan kepada <span className='fw-bolder'>PT. Toyota Astra Motor</span> untuk mengumpulkan, mengolah, menyimpan, mengirim dan memusnahkan data pribadi Saya untuk mendapatkan seluruh layanan sesuai yang tercantum pada
                                  <a href='#'> <span className='link-href'>Kebijakan Privasi Laman Situs Website Toyota.</span></a>
                                </td>
                              </tr>

                              { showModal && (
                                <div className="modal">
                                  <div className="modal-content">
                                    <span className="close" onClick={ () => setShowModal( false ) }>&times;</span>
                                    <PrivacyPolicy closeModal={ closeModal } />
                                  </div>
                                </div>
                              ) }

                              <style jsx>{ `
                                .modal {
                                  display: flex;
                                  position: fixed;
                                  top: 0;
                                  left: 0;
                                  width: 100%;
                                  height: 100%;
                                  background-color: rgba(0, 0, 0, 0.5);
                                  align-items: center;
                                  justify-content: center;
                                  z-index: 1000;
                                  overflow: auto;
                                }
                                .modal-content {
                                  background-color: #fff;
                                  padding: 20px;
                                  border-radius: 10px;
                                  max-width: 900px;
                                  width: 90%;
                                  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
                                  position: relative;
                                }
                                .close {
                                  position: absolute;
                                  top: 10px;
                                  right: 20px;
                                  font-size: 24px;
                                  cursor: pointer;
                                }
                              `}</style>

                            </table>
                          </div> */}
                          <div className="mt-2">
                            <table>
                              <tr>
                                <td style={ { width: "30px", verticalAlign: "middle" } }>
                                  <input
                                    type="checkbox"
                                    style={ { width: "20px" } }
                                    checked={ isChecked2 }
                                    onChange={ handleCheckbox2Change }
                                  />
                                </td>
                                <td style={ { textAlign: "justify" } }>
                                  Saya telah membaca dan menyetujui isi <a href='https://www.toyota.astra.co.id/privacy-policy' target='_blank'><span className='link-href'>kebijakan privasi Laman Situs Website Toyota</span></a> ini.
                                </td>
                              </tr>
                            </table>
                          </div>

                          <button
                            className="btn btn-primary Lanjut mt-4 ms-2"
                            onClick={ submitData }
                          disabled={ !isChecked2 } // TODO: Enable when both checkboxes are checked
                          >
                            Lanjut
                          </button>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

                <div style={ { display: loading ? "none" : activeTab === 0 ? "block" : "none", } } >
                  <div className="tabs-section" style={ { display: loading ? "none" : secondtab === 4 ? "block" : "none", } }>
                    <div>
                      <div className="pt-4">
                        <img
                          src="assets/icon-park-outline_info.svg"
                          className="img-fluid"
                        />
                        <p className="tab-bold-p pt-4">
                          Apakah data yang Anda masukkan sudah benar?
                        </p>
                      </div>
                      <div className="text-start mx-4 mx-md-5">
                        <div className="row">
                          <div className="col-4 p-0">
                            <span className="tab-light-bold-p1">Nama</span>
                          </div>
                          <div className="col-8 p-0">
                            <span className="tab-light-bold-p1">: { uname }</span>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-4 p-0">
                            <span className="tab-light-bold-p1">Email</span>
                          </div>
                          <div className="col-8 p-0">
                            <span className="tab-light-bold-p1">
                              : { uemail }
                            </span>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-4 p-0">
                            <span className="tab-light-bold-p1">VIN</span>
                          </div>
                          <div className="col-8 p-0">
                            <span className="tab-light-bold-p1">: { vin }</span>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-4 p-0">
                            <span className="tab-light-bold-p1">Kendaraan</span>
                          </div>
                          <div className="col-8 p-0">
                            <span className="tab-light-bold-p1">
                              : { kendaraan }
                            </span>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-4 p-0">
                            <span className="tab-light-bold-p1">Warna</span>
                          </div>
                          <div className="col-8 p-0">
                            <span className="tab-light-bold-p1">: { warna }</span>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-4 p-0">
                            <span className="tab-light-bold-p1">
                              Cabang Penerimaan
                            </span>
                          </div>
                          <div className="col-8 p-0">
                            <span className="tab-light-bold-p1">
                              : { preferredBranch }
                            </span>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-4 p-0">
                            <span className="tab-light-bold-p1">
                              Bulan Penerimaan
                            </span>
                          </div>
                          <div className="col-8 p-0">
                            <span className="tab-light-bold-p1">
                              : { selectedDay } {months[selectedMonth - 1]} { selectedYear }
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="mb-4">
                        <button
                          className="btn btn-primary lihat_Diri mt-4"
                          onClick={ () => handleregister( 3 ) }
                        >
                          Lihat Data Diri
                        </button>
                        <button
                          className="btn btn-primary Lanjut mt-4 ms-2"
                          onClick={ submitRegister }
                        >
                          Lanjut
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div style={ { display: loading ? "none" : activeTab === 0 ? "block" : "none", } }>
                  <div className="tabs-section" style={ { display: loading ? "none" : secondtab === 5 ? "block" : "none", } } >
                    <div class="circle-tab pt-4">
                      <a
                        onClick={ () => handleregister( 0 ) }
                        className={ `mx-3 active cursor-pointer` }
                      >
                        <img src="assets/mdi_car-side.png" alt="" />
                      </a>
                      <a href="javascript:void(0)" className={ `mx-4 active` }>
                        <img src="assets/Group (2).png" alt="" />
                      </a>
                      <a href="javascript:void(0)" className={ `mx-3` }>
                        <img src="assets/Group (3).png" alt="" />
                      </a>
                    </div>
                    <div>
                      <div className="d-md-flex justify-content-between mt-4 mx-4 text-start mx-md-5">
                        <p className="tab-bold-p">Verifikasi Email</p>
                        <p className="text-danger Langkah_side_text">
                          Langkah 2 - 3
                        </p>
                      </div>
                      <div className="form-group mx-4 mx-md-5 text-start d-flex justify-content-center py-4 ">
                        <input
                          type="text"
                          className="otp text-center"
                          id="otp1"
                          maxLength="1"
                          value={ otp1 }
                          onChange={ ( e ) =>
                          {
                            setOtp1( e.target.value );
                            if ( e.target.value === "" )
                            {
                              document.getElementById( "otp1" ).focus();
                            } else if ( e.target.value.length === 1 )
                            {
                              document.getElementById( "otp2" ).focus();
                            }
                          } }
                          onKeyPress={ ( e ) =>
                          {
                            // Allow only numbers to be entered
                            const isValidInput = /^\d*$/.test( e.key );
                            const isMaxLengthReached =
                              e.target.value.length >= 1;

                            if ( !isValidInput || isMaxLengthReached )
                            {
                              e.preventDefault();
                            }
                          } }
                        />
                        <input
                          type="text"
                          className="otp text-center"
                          id="otp2"
                          maxLength="1"
                          value={ otp2 }
                          onChange={ ( e ) =>
                          {
                            setOtp2( e.target.value );
                            if ( e.target.value === "" )
                            {
                              document.getElementById( "otp1" ).focus();
                            } else if ( e.target.value.length === 1 )
                            {
                              document.getElementById( "otp3" ).focus();
                            }
                          } }
                          onKeyPress={ ( e ) =>
                          {
                            // Allow only numbers to be entered
                            const isValidInput = /^\d*$/.test( e.key );
                            const isMaxLengthReached =
                              e.target.value.length >= 1;

                            if ( !isValidInput || isMaxLengthReached )
                            {
                              e.preventDefault();
                            }
                          } }
                        />
                        <input
                          type="text"
                          className="otp text-center"
                          id="otp3"
                          maxLength="1"
                          value={ otp3 }
                          onChange={ ( e ) =>
                          {
                            setOtp3( e.target.value );
                            if ( e.target.value === "" )
                            {
                              document.getElementById( "otp2" ).focus();
                            } else if ( e.target.value.length === 1 )
                            {
                              document.getElementById( "otp4" ).focus();
                            }
                          } }
                          onKeyPress={ ( e ) =>
                          {
                            // Allow only numbers to be entered
                            const isValidInput = /^\d*$/.test( e.key );
                            const isMaxLengthReached =
                              e.target.value.length >= 1;
                            if ( !isValidInput || isMaxLengthReached )
                            {
                              e.preventDefault();
                            }
                          } }
                        />
                        <input
                          type="text"
                          className="otp text-center"
                          id="otp4"
                          maxLength="1"
                          value={ otp4 }
                          onChange={ ( e ) =>
                          {
                            setOtp4( e.target.value );
                            if ( e.target.value === "" )
                            {
                              document.getElementById( "otp3" ).focus();
                            } else if ( e.target.value.length === 1 )
                            {
                              document.getElementById( "otp5" ).focus();
                            }
                          } }
                          onKeyPress={ ( e ) =>
                          {
                            // Allow only numbers to be entered
                            const isValidInput = /^\d*$/.test( e.key );
                            const isMaxLengthReached =
                              e.target.value.length >= 1;

                            if ( !isValidInput || isMaxLengthReached )
                            {
                              e.preventDefault();
                            }
                          } }
                        />
                        <input
                          type="text"
                          className="otp text-center"
                          id="otp5"
                          maxLength="1"
                          value={ otp5 }
                          onChange={ ( e ) =>
                          {
                            setOtp5( e.target.value );
                            if ( e.target.value === "" )
                            {
                              document.getElementById( "otp4" ).focus();
                            } else if ( e.target.value.length === 1 )
                            {
                              document.getElementById( "otp6" ).focus();
                            }
                          } }
                          onKeyPress={ ( e ) =>
                          {
                            // Allow only numbers to be entered
                            const isValidInput = /^\d*$/.test( e.key );
                            const isMaxLengthReached =
                              e.target.value.length >= 1;

                            if ( !isValidInput || isMaxLengthReached )
                            {
                              e.preventDefault();
                            }
                          } }
                        />
                        <input
                          type="text"
                          className="otp text-center"
                          id="otp6"
                          maxLength="1"
                          value={ otp6 }
                          onChange={ ( e ) =>
                          {
                            setOtp6( e.target.value );
                            if ( e.target.value === "" )
                            {
                              document.getElementById( "otp5" ).focus();
                            }
                          } }
                          onKeyPress={ ( e ) =>
                          {
                            // Allow only numbers to be entered
                            const isValidInput = /^\d*$/.test( e.key );
                            const isMaxLengthReached =
                              e.target.value.length >= 1;

                            if ( !isValidInput || isMaxLengthReached )
                            {
                              e.preventDefault();
                            }
                          } }
                        />
                      </div>
                      <p className="tab-light-bold-p1 mx-4 mx-md-5 text-start">
                        Silakan masukkan 6 digit kode OTP yang dikirimkan ke
                        email Anda.
                      </p>
                      <div className=" mx-4 mx-md-5 text-start d-flex">
                        <p className="tab-light-bold-p1">
                          Tidak menerima kode verifikasi? silakan{ " " }
                        </p>
                        <p
                          className="text-danger tab-light-bold-p1"
                          style={ {
                            display: timerValue != 0 ? "block" : "none",
                          } }
                        >
                          { " " }
                          &nbsp; klik di sini &nbsp;
                        </p>
                        <p
                          className="text-danger tab-light-bold-p1 cursor-pointer"
                          onClick={ submitRegister }
                          style={ {
                            display: timerValue === 0 ? "block" : "none",
                          } }
                        >
                          &nbsp; klik di sini &nbsp;
                        </p>
                        <p className="tab-light-bold-p1">00:{ timerValue }</p>
                      </div>
                      <div className="mb-4">
                        <button
                          className="btn btn-primary Lanjut mt-4 ms-2"
                          onClick={ submitOtp }
                        >
                          Lanjut
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* download cert if registered */ }
                <div style={ { display: loading ? "none" : activeTab === 0 ? "block" : "none", } }>
                  <div className="tabs-section" style={ { display: loading ? "none" : secondtab === 6 ? "block" : "none", } }>
                    <div class="circle-tab pt-4">
                      <a
                        onClick={ () => handleregister( 0 ) }
                        className={ `mx-3 active cursor-pointer` }
                      >
                        <img src="assets/mdi_car-side.png" alt="" />
                      </a>
                      { register === 2 && (
                        <a
                          onClick={ () => handleregister( 2 ) }
                          className={ `mx-4 active cursor-pointer` }
                        >
                          <img src="assets/Group (2).png" alt="" />
                        </a>
                      ) }
                      { register === 1 && (
                        <a
                          onClick={ () => handleregister( 1 ) }
                          className={ `mx-4 active cursor-pointer` }
                        >
                          <img src="assets/Group (2).png" alt="" />
                        </a>
                      ) }

                      <a href="javascript:void(0)" className={ `mx-3 active` }>
                        <img src="assets/Group (3).png" alt="" />
                      </a>
                    </div>
                    <div>
                      <div className="d-md-flex justify-content-between mt-4 mx-4 text-start mx-md-5">
                        <p></p>
                        <p className="text-danger Langkah_side_text">
                          Langkah 3 - 3
                        </p>
                      </div>
                      <div className={ "d-block" } >
                        <ul className="nav px-lg-5 px-2 justify-content-center">

                          {/* Tab Program Name */ }
                          {(downloadWarranty !== null || downloadCoating !== null ) && (
                            <>
                              <li className="nav-item custom_border_radios_add px-1">
                                <button
                                  className={ `tabs nav-link py-2 px-4 li_text_1 ${ activeTab1 === 0 ? "active1" : "non_active" }` }
                                  onClick={ () => handleTabClick1( 0 ) }
                                >
                                  { programName }
                                </button>
                              </li>
                            </>
                          ) }

                          {/* Tab Extended Warranty */ }
                          { downloadWarranty != null && (
                            <>
                              <li className="nav-item custom_border_radios_add px-1">
                                <button
                                  className={ `tabs nav-link py-2 px-4 li_text_1 ${ activeTab1 === 1 ? "active1" : "non_active" }` }
                                  onClick={ () => handleTabClick1( 1 ) }
                                >
                                  Extended Warranty
                                </button>
                              </li>
                            </>
                          ) }

                          {/* Tab Coating */ }
                          { downloadCoating != null && (
                            <>
                              <li className="nav-item custom_border_radios_add px-1">
                                <button
                                  className={ `tabs nav-link py-2 px-4 li_text_1 ${ activeTab1 === 2 ? "active1" : "non_active" }` }
                                  onClick={ () => handleTabClick1( 2 ) }
                                >
                                  Coating
                                </button>
                              </li>
                            </>
                          ) }

                        </ul>
                      </div>
                      {/* {originProgramName == 'T-CARE + XTRA EZ' ? (
                        <button
                          className={ `tabs nav-link py-2 px-4 li_text_1 non_active disabled px-2 py-1 m-auto` }
                          style={{backgroundColor:'#c3c3c3', color:"white", borderColor:"gray"}}
                          // onClick={ () => handleTabClick1( 2 ) }
                        >
                          Xtra Credit
                        </button>
                      ) : null} */}
                      <div className="pt-4">
                        <p className="tab-bold-p">
                          Terima Kasih
                          <br />
                          Bapak/Ibu { uname }
                        </p>
                      </div>
                      <div className="text-start mx-4 mx-md-5">
                        {(potentialDataSubmission) && (
                          <p className="tab-light-bold-p text-center fw-normal" dangerouslySetInnerHTML={ { __html: potentialDataSubmission } } />
                        )}
                        {(downloadAbility) ? (
                          <p className="tab-light-bold-p text-center fw-normal mb-3">
                            Untuk mendapatkan sertifikat { getTabName() }, silakan lakukan download melalui:
                          </p>
                        ) : (
                          <p className="tab-light-bold-p text-center fw-normal" dangerouslySetInnerHTML={ { __html: submission } } />
                        )}
                      </div>

                      {(downloadAbility) && (
                        <div className="d-flex justify-content-center custom_size_of_font buttons_custom_gap mx-5">
                          <div className="d-flex flex-column">
                            <button
                              className="download_pdf_buttons"
                              onClick={ handleDownload }
                            >
                              <img src="assets/icon_download.png" />
                            </button>
                            <p
                              className="mt-2 tab-bold-p"
                              style={ { color: "#DF1D1D" } }
                            >
                              PDF
                            </p>
                          </div>
                          <div className="d-flex flex-column">
                            <button
                              className="download_pdf_buttons"
                              onClick={ sendEmail }
                            >
                              <img src="assets/icon_email.png" />
                            </button>
                            <p
                              className="mt-2 tab-bold-p"
                              style={ { color: "#DF1D1D" } }
                            >
                              Email
                            </p>
                          </div>
                          <div className="d-flex flex-column">
                            <button
                              className="download_pdf_buttons"
                              onClick={ handlePrint }
                            >
                              <img src="assets/icon_print.png" />
                            </button>
                            <p
                              className="mt-2 tab-bold-p"
                              style={ { color: "#DF1D1D" } }
                            >
                              Print
                            </p>
                            {/* <PDFViewer pdfUrl={download} ref={pdfRef} /> */ }
                          </div>
                        </div>
                      )}

                      <div className="mb-4">
                        <button
                          className="btn btn-primary lihat_Diri_1 mt-4"
                          onClick={ () => handleregister( 0 ) }
                        >
                          <img src="assets/Left.png" className="pe-2" />
                          Kembali ke Halaman Awal
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                { loading && (
                  <div className="spinner-overlay add_custom_properties">
                    <Oval
                      height="60"
                      width="60"
                      radius="9"
                      color="black"
                      ariaLabel="three-dots-loading"
                      secondaryColor="grey"
                      wrapperStyle={ { marginTop: "10%", marginBottom: "10%" } }
                    />
                  </div>
                ) }

                {/* service history */ }
                <div style={ { display: loading ? "none" : activeTab === 1 ? "block" : "none", } } >
                  <div className="tabs-section" style={ { display: loading ? "none" : Active_tab1 === 1 ? "block" : "none", } }>
                    <div>
                      <div className="form-group mx-4 mx-md-5 text-start pt-4 ">
                        <p className="custom_class_tab_discrip">
                          Mau cari tau catatan servis pemakaian Gratis Servis
                          Berkala Toyota Anda? Cek disini:
                        </p>
                        <label className="input_label">
                          Nomor Rangka Kendaraan
                        </label>
                        <input
                          type="email"
                          className="form-control Masukkan"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                          placeholder="Masukkan 17 Digit No. Rangka Kendaraan"
                          value={ vinn }
                          onChange={ ( e ) => setVinn( e.target.value ) }
                        />
                      </div>
                      <div className="form-group mx-4 mx-md-5 text-start">
                        <label className="input_label">Email</label>
                        <input
                          type="email"
                          className="form-control Masukkan"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                          placeholder=""
                          value={ emaill }
                          onChange={ ( e ) => setEmaill( e.target.value ) }
                        />
                      </div>
                      <div className="form-group mx-4 mx-md-5 text-start">
                        <p className="custom_discrip_tab">
                          *Masukkan alamat email yang didaftarkan pada
                          sertifikat elektronik
                        </p>
                      </div>

                      <div className="mb-4">
                        <button
                          className="btn btn-primary Lanjut mt-4 ms-2"
                          onClick={ serviceHistory }
                        >
                          Lanjut
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tabs-section"
                    style={ {
                      display: loading
                        ? "none"
                        : Active_tab1 === 2
                          ? "block"
                          : "none",
                    } }
                  >
                    <div>
                      <div className="pt-4">
                        <img
                          src="assets/icon-park-outline_info.svg"
                          className="img-fluid"
                        />
                        <p className="tab-discription-p pt-4 px-4">{ Nodata }</p>
                      </div>
                      <div className="mb-4">
                        <button
                          className="btn btn-primary Lanjut mt-4 ms-2"
                          onClick={ () => goBack( 1 ) }
                        >
                          Lanjut
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tabs-section"
                    style={ {
                      display: loading
                        ? "none"
                        : Active_tab1 === 3
                          ? "block"
                          : "none",
                    } }
                  >
                    <div className="row">
                      <div className="col-md-12">
                        <div className="text-start px-5 pt-4">
                          <p className="tab-discription-p">Hai Bapak/Ibu <span className='fw-bold'>{ checkServiceNmae }</span></p>
                          <p className="tab-discription-p">Pemilik Kendaraan:</p>

                          <div className='mt-3 bk-info'>
                            <p>
                              <span className="tab-info-p">Nama</span>
                              <span className="tab-info-p"> : { checkServiceNmae }</span>
                            </p>

                            <p>
                              <span className="tab-info-p">Model</span>
                              <span className="tab-info-p">: { checkSeriveModel }</span>
                            </p>
                          </div>
                        </div>

                        <div className="text-start px-5 pt-4 fw-bolder">
                          Berikut adalah catatan Servis Berkala Mobil Toyota Anda:
                        </div>

                        <div class="card-body">
                          <div
                            className="text-start px-4 fw-bold mb-2 bk-program"
                            onClick={ toggleTableVisibility }
                            style={ { cursor: "pointer" } }
                          >
                            Catatan Servis Program <span className="text-danger">{serviceHistoryProgram}</span>
                            <span className="float-end">
                              { isTableVisible ? " ▼" : " ▲" }
                            </span>
                          </div>
                          { isTableVisible && (
                            <div className="table-responsive">
                              <table class="table mb-0">
                                <thead>
                                  <tr>
                                    <th scope="col">Servis</th>
                                    <th scope="col">Tanggal Servis</th>
                                    <th scope="col">Bengkel Servis</th>
                                    <th scope="col">Tepat Waktu</th>
                                    <th scope="col">Max Servis Slenjutnya</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  { tableData.map( ( rowData, index ) => (
                                    <tr key={ index } className="custom_border_tr">
                                      <td className="custom_border_set_td text-left">{ rowData.no }</td>
                                      <td className="custom_border_set_td">{ rowData.repair_date ?? "-" } </td>
                                      <td className="custom_border_set_td">{ rowData.dealer }</td>
                                      <td className="custom_border_set_td">{ rowData.punctual }</td>
                                      <td className="custom_border_set_td">{ rowData.next }</td>
                                    </tr>
                                  ) ) }
                                </tbody>
                              </table>
                            </div>
                          ) }
                        </div>

                        { tableDataCoating && tableDataCoating.length > 0 && (
                          <div className="card-body">
                            <div
                              className="text-start px-4 fw-bold mb-2 bk-program"
                              onClick={ toggleTableVisibilityCoating }
                              style={ { cursor: "pointer" } }
                            >
                              Catatan Servis Program <span className="text-danger">Coating</span>
                              <span className="float-end">
                                { isTableVisibleCoating ? " ▼" : " ▲" }
                              </span>
                            </div>
                            { isTableVisibleCoating && (
                              <div className="table-responsive">
                                <table className="table mb-0">
                                  <thead>
                                    <tr>
                                      <th scope="col">Service</th>
                                      <th scope="col">Nama Program</th>
                                      <th scope="col">Tanggal Servis</th>
                                      <th scope="col">Bengkel Servis</th>
                                      <th scope="col">Max Servis Slenjutnya</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    { tableDataCoating.map( ( rowDataCoating, index ) => (
                                      <tr key={ index } className="custom_border_tr">
                                        <td className="custom_border_set_td text-center">{ rowDataCoating.no }</td>
                                        <td className="custom_border_set_td text-left">{ rowDataCoating.programName }</td>
                                        <td className="custom_border_set_td">{ rowDataCoating.repair_date ?? "-" }</td>
                                        <td className="custom_border_set_td">{ rowDataCoating.companyName ?? "-" }</td>
                                        <td className="custom_border_set_td">{ rowDataCoating.next ?? "-" }</td>
                                      </tr>
                                    ) ) }
                                  </tbody>
                                </table>
                              </div>
                            ) }
                          </div>
                        ) }

                        <div className="text-start px-5 pt-4 fw-bolder">
                          Jangan lupa Servis Berkala Toyota Anda setiap 6 bulan di bengkel resmi Toyota!
                        </div>
                      </div>

                      <div className="mb-4">
                        <button
                          className="btn btn-primary lihat_Diri_2 mt-4"
                          onClick={ () => goBack( 1 ) }
                        >
                          <svg
                            className="me-2"
                            xmlns="http://www.w3.org/2000/svg"
                            width="7"
                            height="13"
                            viewBox="0 0 7 13"
                            fill="none"
                          >
                            <path
                              d="M5.5 11.167L2.46392 7.62489C1.90924 6.97778 1.90924 6.02288 2.46392 5.37576L5.5 1.83366"
                              stroke="white"
                              stroke-width="2.16"
                              stroke-linecap="round"
                            />
                          </svg>
                          Kembali ke Halaman Awal
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* recomend section */ }
            <div className='container container-recommend'>
              <div className="row mt-5">
                <span className="recommend-section">
                  Cek rekomendasi produk tambahan untuk servis T-CARE Anda!
                </span>
                <div>
                  <button
                    className="btn custom-btn-dark me-3 mt-4 ms-2"
                    onClick={ goToRecommendation }
                  >
                    Go to recommendation
                  </button>
                </div>
              </div>
            </div>

          </div >
        </div>

        {/* youtube section */ }
        <div div className="container px-md-5 mt-5" >
          <iframe id="t_care" className="w-100 rounded-4 custom-h-YT-v" src="https://www.youtube.com/embed/30IGvG4oikU?si=e6VTnyoq8jLDbb8q&enablejsapi=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>

        

        <div className="container mt-5">
          <div className="row align-items-center">
            <div className="col-12 col-md-7 text-start">
              <p className="text-danger">Toyota SERVICE</p>
              <h1>Manfaatkan T-CARE dengan program Express Maintenance</h1>
              <NavLink
                to="/services"
                className="btn custom-btn-dark w-50 mt-4  d-lg-block d-none"
              >
                Telusuri Express Maintenance
              </NavLink>
            </div>
            <div className="col-12 col-md-5 text-center mt-lg-0 mt-4">
              <img src="assets/services.png" className="w-100" />
            </div>
            <div className="mt-4 mb-5">
              <NavLink
                to="/services"
                className="btn custom-btn-dark me-3  d-lg-none"
              >
                Telusuri Express Maintenance
              </NavLink>
            </div>
          </div>
        </div>

        <div className="container p-lg-5">
          <b>
            Download Informasi GBSB atau lihat hal-hal yang sering ditanyakan
          </b>
          <div className="mt-5">
            <button className="btn custom-btn-dark me-3" onClick={ downloadFile }>
              Download info GBSB
            </button>
            <NavLink to="/faq" className="btn custom-btn-dark">
              Go to FAQ Page
            </NavLink>
          </div>
        </div>

        <div className="container mt-5 mb-5">
          <div className="logos d-flex justify-content-center mt-5 mb-4">
            <div className="mx-2">
              <img src="assets/quality-service.png" alt="t-care-img" />
            </div>
            <div className="mx-2">
              <img src="assets/genuine-parts (1).png" alt="t-care-img" />
            </div>
            <div className="mx-2">
              <img src="assets/tmo.png" alt="t-care-img" />
            </div>
          </div>
        </div>

      </div>
      <AftersalesExploreService showItem={[0,1,2,4,5,6]} />
      <Footer></Footer>
    </div>
  );

}
export default TCare;
